import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { api } from "@/lib/api";

/** A unit's Coursera learners who are on no team — its trained resources. */
export const TrainedDialog = ({ team, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!team) return;
    setRows(null);
    api.get("/people/trained", { params: { plant: team.plant } }).then((r) => setRows(r.data.learners));
  }, [team]);
  return (
    <Dialog open={!!team} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl rounded-none" data-testid="trained-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-black">
            {team?.plant} · Trained resources
          </DialogTitle>
          <DialogDescription>
            Coursera learners of {team?.name} who are not on a team yet. Their progress is on{" "}
            <Link to="/training" className="text-primary hover:underline">Training Status</Link>.
          </DialogDescription>
        </DialogHeader>
        {!rows ? (
          <Loader2 className="mx-auto h-5 w-5 animate-spin text-muted-foreground" />
        ) : (
          <ul className="max-h-[55vh] divide-y divide-border overflow-y-auto border border-border" data-testid="trained-list">
            {rows.map((l) => (
              <li key={l.email || l.name} className="flex items-center justify-between gap-3 px-3 py-2 text-xs">
                <span className="min-w-0">
                  <span className="block truncate font-bold">{l.name}</span>
                  <span className="font-data block truncate text-muted-foreground">
                    {[l.department, l.learning_path].filter(Boolean).join(" · ") || l.email}
                  </span>
                </span>
                <span className="font-data shrink-0 font-bold">{l.completion_pct}%</span>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
